export default {
  getDoctorTree: '/system-api/webapi/department/get-tree', // 获取科室树结构
  listUsers: '/system-api/webapi/user/list-users' // 搜索
}
